import React, { useContext } from 'react';
import { type Template, type ConfluenceTemplate } from './types';
import { useEffect } from 'react';
import { isConfluenceTemplate } from './utils';

interface TemplateContextType {
	template?: Template;
	setActiveTemplatePreview: (template: Template) => void;
	projectSpaceId?: number | null;
}

const TemplateContext = React.createContext<TemplateContextType>({
	template: undefined,
	setActiveTemplatePreview: () => {},
	projectSpaceId: null,
});

export const useTemplate = () => useContext(TemplateContext);
export const TemplateProvider = TemplateContext.Provider;

export const usePreloadPreviews = (templates: Template[], isPostExpand: boolean) => {
	useEffect(() => {
		templates.filter<ConfluenceTemplate>(isConfluenceTemplate).forEach((t) => {
			const img = new Image();
			img.src = isPostExpand ? t.preview.postExpand.default : t.preview.preExpand.default;
		});
	}, [isPostExpand, templates]);
};
